
import React from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { Stack } from '@mui/material';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.action.hover,

    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({

    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));



export default function NewZScore({zee}) {
    function createData(name, name1, name2, val, val1, val2, val3, val4) {
        return { name, name1, name2, val, val1, val2, val3, val4 };
    }
    
    const rows = [
        createData('Return on total assets','Earnings before int & taxes<span style="border-top: 2px solid black; display: inline-block; width: 100%; margin: 0;"/>Total assets', '', (zee[0]?.earningsBeforeIntAndTax), (zee[0]?.totalAssets), (zee[0]?.calculationForReturnOnTotalAssets), (zee[0]?.weightFactorForReturnOnTotalAssets), (zee[0]?.returnOnTotalAssets)),
        createData('Sales to Total Assets', 'Net sales <span style="border-top: 2px solid black; display: inline-block; width: 100%; margin: 0;"/>Total assets', '', (zee[0]?.netSales), (zee[0]?.totalAssets),  (zee[0]?.calculationForSalesOfTotalAssets), (zee[0]?.weightFactorForSalesOfTotalAssets), (zee[0]?.salesOfTotalAssets)),
        createData('Equity to Debt', 'Equity<span style="border-top: 2px solid black; display: inline-block; width: 100%; margin: 0;"/>Total liabilities',  '', (zee[0]?.retainedEarnings), (zee[0]?.totalLiabilities),  (zee[0]?.calculationForEquityToDebt), (zee[0]?.weightFactorForEquityToDebt), (zee[0]?.equityToDebt)),
        createData('Working Capital to total assets', 'Working capital<span style="border-top: 2px solid black; display: inline-block; width: 100%; margin: 0;"/>Total assets',  '', (zee[0]?.workingCapital), (zee[0]?.totalAssets),  (zee[0]?.calculationForWorkingCapitalToTotalAssets), (zee[0]?.weightFactorForWorkingCapitalToTotalAssets), (zee[0]?.workingCapitalToTotalAssets)),
        createData('Retained earnings to total assets', 'Retained earnings<span style="border-top: 2px solid black; display: inline-block; width: 100%; margin: 0;"/>Total assets',  '', (zee[0]?.retainedEarnings), (zee[0]?.totalAssets),  (zee[0]?.calculationForRetainedEarningsToTotalAssets), (zee[0]?.weightFactorForRetainedEarningsToTotalAssets), (zee[0]?.retainedEarningsToTotalAssets)),
    ];
    const rows1 = [
        createData('Return on total assets', 'Earnings before int & taxes<span style="border-top: 2px solid black; display: inline-block; width: 100%; margin: 0;"/>Total assets', '', (zee[1]?.earningsBeforeIntAndTax), (zee[1]?.totalAssets), (zee[1]?.calculationForReturnOnTotalAssets), (zee[1]?.weightFactorForReturnOnTotalAssets), (zee[1]?.returnOnTotalAssets)),
        createData('Sales to Total Assets', 'Net sales <span style="border-top: 2px solid black; display: inline-block; width: 100%; margin: 0;"/>Total assets', '', (zee[1]?.netSales), (zee[1]?.totalAssets), (zee[1]?.calculationForSalesOfTotalAssets), (zee[1]?.weightFactorForSalesOfTotalAssets), (zee[1]?.salesOfTotalAssets)),
        createData('Equity to Debt', 'Equity<span style="border-top: 2px solid black; display: inline-block; width: 100%; margin: 0;"/>Total liabilities', '', (zee[1]?.retainedEarnings), (zee[1]?.totalLiabilities), (zee[1]?.calculationForEquityToDebt), (zee[1]?.weightFactorForEquityToDebt), (zee[1]?.equityToDebt)),
        createData('Working Capital to total assets', 'Working capital<span style="border-top: 2px solid black; display: inline-block; width: 100%; margin: 0;"/>Total assets', '', (zee[1]?.workingCapital), (zee[1]?.totalAssets), (zee[1]?.calculationForWorkingCapitalToTotalAssets), (zee[1]?.weightFactorForWorkingCapitalToTotalAssets), (zee[1]?.workingCapitalToTotalAssets)),
        createData('Retained earnings to total assets', 'Retained earnings<span style="border-top: 2px solid black; display: inline-block; width: 100%; margin: 0;"/>Total assets', '', (zee[1]?.retainedEarnings), (zee[1]?.totalAssets), (zee[1]?.calculationForRetainedEarningsToTotalAssets), (zee[1]?.weightFactorForRetainedEarningsToTotalAssets), (zee[1]?.retainedEarningsToTotalAssets)),
    ];
    
    const rows2 = [
        createData('Return on total assets', 'Earnings before int & taxes<span style="border-top: 2px solid black; display: inline-block; width: 100%; margin: 0;"/>Total assets', '', (zee[2]?.earningsBeforeIntAndTax), (zee[2]?.totalAssets), (zee[2]?.calculationForReturnOnTotalAssets), (zee[2]?.weightFactorForReturnOnTotalAssets), (zee[2]?.returnOnTotalAssets)),
        createData('Sales to Total Assets', 'Net sales <span style="border-top: 2px solid black; display: inline-block; width: 100%; margin: 0;"/>Total assets', '', (zee[2]?.netSales), (zee[2]?.totalAssets), (zee[2]?.calculationForSalesOfTotalAssets), (zee[2]?.weightFactorForSalesOfTotalAssets), (zee[2]?.salesOfTotalAssets)),
        createData('Equity to Debt', 'Equity<span style="border-top: 2px solid black; display: inline-block; width: 100%; margin: 0;"/>Total liabilities', '', (zee[2]?.retainedEarnings), (zee[2]?.totalLiabilities), (zee[2]?.calculationForEquityToDebt), (zee[2]?.weightFactorForEquityToDebt), (zee[2]?.equityToDebt)),
        createData('Working Capital to total assets', 'Working capital<span style="border-top: 2px solid black; display: inline-block; width: 100%; margin: 0;"/>Total assets', '', (zee[2]?.workingCapital), (zee[2]?.totalAssets), (zee[2]?.calculationForWorkingCapitalToTotalAssets), (zee[2]?.weightFactorForWorkingCapitalToTotalAssets), (zee[2]?.workingCapitalToTotalAssets)),
        createData('Retained earnings to total assets', 'Retained earnings<span style="border-top: 2px solid black; display: inline-block; width: 100%; margin: 0;"/>Total assets', '', (zee[2]?.retainedEarnings), (zee[2]?.totalAssets), (zee[2]?.calculationForRetainedEarningsToTotalAssets), (zee[2]?.weightFactorForRetainedEarningsToTotalAssets), (zee[2]?.retainedEarningsToTotalAssets)),
    ];
    const rows3 = [
        createData('Return on total assets', 'Earnings before int & taxes<span style="border-top: 2px solid black; display: inline-block; width: 100%; margin: 0;"/>Total assets', '', (zee[3]?.earningsBeforeIntAndTax), (zee[3]?.totalAssets), (zee[3]?.calculationForReturnOnTotalAssets), (zee[3]?.weightFactorForReturnOnTotalAssets), (zee[3]?.returnOnTotalAssets)),
        createData('Sales to Total Assets', 'Net sales <span style="border-top: 2px solid black; display: inline-block; width: 100%; margin: 0;"/>Total assets', '', (zee[3]?.netSales), (zee[3]?.totalAssets), (zee[3]?.calculationForSalesOfTotalAssets), (zee[3]?.weightFactorForSalesOfTotalAssets), (zee[3]?.salesOfTotalAssets)),
        createData('Equity to Debt', 'Equity<span style="border-top: 2px solid black; display: inline-block; width: 100%; margin: 0;"/>Total liabilities', '', (zee[3]?.retainedEarnings), (zee[3]?.totalLiabilities), (zee[3]?.calculationForEquityToDebt), (zee[3]?.weightFactorForEquityToDebt), (zee[3]?.equityToDebt)),
        createData('Working Capital to total assets', 'Working capital<span style="border-top: 2px solid black; display: inline-block; width: 100%; margin: 0;"/>Total assets', '', (zee[3]?.workingCapital), (zee[3]?.totalAssets), (zee[3]?.calculationForWorkingCapitalToTotalAssets), (zee[3]?.weightFactorForWorkingCapitalToTotalAssets), (zee[3]?.workingCapitalToTotalAssets)),
        createData('Retained earnings to total assets', 'Retained earnings<span style="border-top: 2px solid black; display: inline-block; width: 100%; margin: 0;"/>Total assets', '', (zee[3]?.retainedEarnings), (zee[3]?.totalAssets), (zee[3]?.calculationForRetainedEarningsToTotalAssets), (zee[3]?.weightFactorForRetainedEarningsToTotalAssets), (zee[3]?.retainedEarningsToTotalAssets)),
    ];
    
    
       return (
        <>
            {/* <Box
                sx={{

                    backgroundColor: 'white',
                }}
            >
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell className='text-muted'>03/12/22</StyledTableCell>
                                <StyledTableCell className='text-muted'>03/12/21</StyledTableCell>
                                <StyledTableCell className='text-muted'>03/12/20</StyledTableCell>
                              
                                <StyledTableCell align="right" className='text-muted'>03/12/19</StyledTableCell>
                                
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <StyledTableRow >
                                <StyledTableCell component="th" scope="row">
                                    <div >Z Score</div>
                                </StyledTableCell>
                              
                                <StyledTableCell align="left" > 0.0000 </StyledTableCell>
                                <StyledTableCell align="left" >
                                    0.00<br />12:03:45 PM
                                </StyledTableCell>
                                <StyledTableCell align="left" >
                                    0.00<br />12:03:45 PM
                                </StyledTableCell>
                                <StyledTableCell align="left" > 0.0000 </StyledTableCell>
                            </StyledTableRow>
                        </TableBody>

                        <TableHead>
                            <TableRow>
                                <StyledTableCell className='text-muted'>03/12/22</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell className='text-muted'>Weight Factor</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row) => (
                                <StyledTableRow key={row.name}>
                                    <StyledTableCell component="th" scope="row">
                                        <div >{row.name}</div>
                                    </StyledTableCell>
                                    <StyledTableCell align="left" >
                                        {row.name1}<br />{row.name2} </StyledTableCell>
                                    <StyledTableCell align="left" >
                                        {row.val}<br />{row.val1} </StyledTableCell>
                                    <StyledTableCell align="left" >{row.val2}</StyledTableCell>
                                    <StyledTableCell align="left" >{row.val3}</StyledTableCell>
                                    <StyledTableCell align="left" >{row.val4}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>

                        <TableHead>
                            <TableRow>
                                <StyledTableCell className='text-muted'>03/12/21</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell className='text-muted'>Weight Factor</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row) => (
                                <StyledTableRow key={row.name}>
                                    <StyledTableCell component="th" scope="row">
                                        <div >{row.name}</div>
                                    </StyledTableCell>
                                    <StyledTableCell align="left" >
                                        {row.name1}<br />{row.name2} </StyledTableCell>
                                    <StyledTableCell align="left" >
                                        {row.val}<br />{row.val1} </StyledTableCell>
                                    <StyledTableCell align="left" >{row.val2}</StyledTableCell>
                                    <StyledTableCell align="left" >{row.val3}</StyledTableCell>
                                    <StyledTableCell align="left" >{row.val4}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell className='text-muted'>03/12/20</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell className='text-muted'>Weight Factor</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row) => (
                                <StyledTableRow key={row.name}>
                                    <StyledTableCell component="th" scope="row">
                                        <div >{row.name}</div>
                                    </StyledTableCell>
                                    <StyledTableCell align="left" >
                                        {row.name1}<br />{row.name2} </StyledTableCell>
                                    <StyledTableCell align="left" >
                                        {row.val}<br />{row.val1} </StyledTableCell>
                                    <StyledTableCell align="left" >{row.val2}</StyledTableCell>
                                    <StyledTableCell align="left" >{row.val3}</StyledTableCell>
                                    <StyledTableCell align="left" >{row.val4}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell className='text-muted'>03/12/19</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell className='text-muted'>Weight Factor</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row) => (
                                <StyledTableRow key={row.name}>
                                    <StyledTableCell component="th" scope="row">
                                        <div >{row.name}</div>
                                    </StyledTableCell>
                                    <StyledTableCell align="left" >
                                        {row.name1}<br />{row.name2} </StyledTableCell>
                                    <StyledTableCell align="left" >
                                        {row.val}<br />{row.val1} </StyledTableCell>
                                    <StyledTableCell align="left" >{row.val2}</StyledTableCell>
                                    <StyledTableCell align="left" >{row.val3}</StyledTableCell>
                                    <StyledTableCell align="left" >{row.val4}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>


                    </Table>
                </TableContainer>
            </Box> */}
             <Box
                sx={{

                    backgroundColor: 'white',
                }}
            >
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell className='text-muted'align="center">{zee[0]?.formattedValue}</StyledTableCell>
                                <StyledTableCell className='text-muted'align="center">{zee[1]?.formattedValue}</StyledTableCell>
                                <StyledTableCell className='text-muted'align="center">{zee[2]?.formattedValue}</StyledTableCell>
                                <StyledTableCell align="center" className='text-muted'>{zee[3]?.formattedValue}</StyledTableCell>
                                
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <StyledTableRow >
                                <StyledTableCell component="th" scope="row">
                                    <div >Z Score</div>
                                </StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell align="center" >{zee[0]?.zScore}  </StyledTableCell>
                                <StyledTableCell align="center" >
                                {zee[1]?.zScore}  
                                </StyledTableCell>
                                <StyledTableCell align="center" >
                                {zee[2]?.zScore}  
                                </StyledTableCell>
                                <StyledTableCell align="center" >{zee[3]?.zScore}   </StyledTableCell>
                            </StyledTableRow>
                        </TableBody>

                        <TableHead>
                            <TableRow>
                                <StyledTableCell className='text-muted'>{zee[0]?.formattedValue}</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell className='text-muted'align="center">Weight Factor</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows?.map((row) => (
                                <StyledTableRow key={row?.name}>
                                    <StyledTableCell component="th" scope="row">
                                        <div >{row?.name}</div>
                                    </StyledTableCell>
                                    <StyledTableCell align="left" sx={{ width: "14%" }}>
                                        <div dangerouslySetInnerHTML={{ __html:row?.name1  }} />
                                        </StyledTableCell>
                                 
                                       <StyledTableCell align="center" >
                                        {row?.val?.toLocaleString("en-US")}
                                        <hr style={{margin:0,color:"",borderTop:"2px solid black"}}/>
                                        {row?.val1?.toLocaleString("en-US")}
                                         </StyledTableCell>
                                    <StyledTableCell align="center" >{row?.val2}</StyledTableCell>
                                    <StyledTableCell align="center" >{row?.val3}</StyledTableCell>
                                    <StyledTableCell align="center" >{row?.val4}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>

                        <TableHead>
                            <TableRow>
                                <StyledTableCell className='text-muted'>{zee[1]?.formattedValue}</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell className='text-muted'>Weight Factor</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {rows1?.map((row) => (
                                <StyledTableRow key={row?.name}>
                                    <StyledTableCell component="th" scope="row">
                                        <div >{row?.name}</div>
                                    </StyledTableCell>
                                    <StyledTableCell align="left" sx={{ width: "14%" }}>
                                        <div dangerouslySetInnerHTML={{ __html:row?.name1  }} />
                                        </StyledTableCell>
                                 
                                       <StyledTableCell align="center" >
                                        {row?.val?.toLocaleString("en-US")}
                                        <hr style={{margin:0,color:"",borderTop:"2px solid black"}}/>
                                        {row?.val1?.toLocaleString("en-US")}
                                         </StyledTableCell>
                                    <StyledTableCell align="center" >{row?.val2}</StyledTableCell>
                                    <StyledTableCell align="center" >{row?.val3}</StyledTableCell>
                                    <StyledTableCell align="center" >{row?.val4}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell className='text-muted'>{zee[2]?.formattedValue}</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell className='text-muted'>Weight Factor</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {rows2?.map((row) => (
                                <StyledTableRow key={row?.name}>
                                    <StyledTableCell component="th" scope="row">
                                        <div >{row?.name}</div>
                                    </StyledTableCell>
                                    <StyledTableCell align="left" sx={{ width: "14%" }}>
                                        <div dangerouslySetInnerHTML={{ __html:row?.name1  }} />
                                        </StyledTableCell>
                                 
                                       <StyledTableCell align="center" >
                                        {row?.val?.toLocaleString("en-US")}
                                        <hr style={{margin:0,color:"",borderTop:"2px solid black"}}/>
                                        {row?.val1?.toLocaleString("en-US")}
                                         </StyledTableCell>
                                    <StyledTableCell align="center" >{row?.val2}</StyledTableCell>
                                    <StyledTableCell align="center" >{row?.val3}</StyledTableCell>
                                    <StyledTableCell align="center" >{row?.val4}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell className='text-muted'>{zee[3]?.formattedValue}</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                                <StyledTableCell className='text-muted'>Weight Factor</StyledTableCell>
                                <StyledTableCell >&nbsp;</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {rows3?.map((row) => (
                                <StyledTableRow key={row?.name}>
                                    <StyledTableCell component="th" scope="row">
                                        <div >{row?.name}</div>
                                    </StyledTableCell>
                                    <StyledTableCell align="left" sx={{ width: "14%" }}>
                                        <div dangerouslySetInnerHTML={{ __html:row?.name1  }} />
                                        </StyledTableCell>
                                 
                                       <StyledTableCell align="center" >
                                        {row?.val?.toLocaleString("en-US")}
                                        <hr style={{margin:0,color:"black",borderTop:"2px solid black"}}/>
                                        {row?.val1?.toLocaleString("en-US")}
                                         </StyledTableCell>
                                    <StyledTableCell align="center" >{row?.val2}</StyledTableCell>
                                    <StyledTableCell align="center" >{row?.val3}</StyledTableCell>
                                    <StyledTableCell align="center" >{row?.val4}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>


                    </Table>
                </TableContainer>
            </Box>
        </>
    )
}